import { render } from "./FancyImage.vue?vue&type=template&id=720883ff&scoped=true"
import script from "./FancyImage.vue?vue&type=script&lang=js"
export * from "./FancyImage.vue?vue&type=script&lang=js"

import "./FancyImage.vue?vue&type=style&index=0&id=720883ff&lang=scss&scoped=true"

import exportComponent from "C:\\__MRYNK\\_2022\\ynk-css-everydays\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720883ff"]])

export default __exports__